import { $, _ } from "../../../../helpers/dom-selectors.js";
import makeFileError from "../../../global-components/file-upload/file-error.js";
import makeFileForms from "../../../global-components/file-upload/file-forms.js";
import makeProgressComponents from "../../../global-components/file-upload/progress.js";
import makeForms from "../../../global-components/forms/forms.js";
import makeReOrderModal from "../../../global-components/forms/re-order-modal.js";
import APP_EVENTS from "../init/events.js";
import makeAddInstrument from "./add-btn.js";
const forms = $(document, '.form');
const musicianForms = makeForms({
    forms,
    overlayEl: _('resultOverlay'),
    entity: 'Musician',
    events: APP_EVENTS,
    action: 'add-musician-clicked'
});
const fileForms = makeFileForms({
    wrappers: forms
});
const fileError = makeFileError({
    overlayEl: _('fileErrorOverlay')
});
const progressComponents = makeProgressComponents({
    wrappers: $(document, '.progress-wrapper')
});
const addInstrumentBtn = makeAddInstrument({
    addBtns: $(document, '.add-input-btn'),
    forms
});
const reOrderModal = makeReOrderModal({
    overlayEl: _('resultOverlay'),
    entity: 'Musician'
});
const APP_COMPONENTS = Object.freeze({
    musicianForms,
    fileForms,
    fileError,
    progressComponents,
    addInstrumentBtn,
    reOrderModal
});
export default APP_COMPONENTS;
